import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//解决vue路由重复导航错误
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const constantRoutes = [
  
  {
    name: "引导页",
    path: "/",
    component: () => import('@/components/index'),
  },

  //web端

  //首页
  {
    name: "web首页",
    path: "/web/",
    component: () => import('@/views/web/index'),
  },
  //user
  {
    name: "账号管理",
    path: "/web/app/user/list",
    hidden: true,
    component: () => import('@/views/web/app/user/list'),
  },
  {
    name: "维护账号",
    path: "/web/app/user/edit",
    hidden: true,
    component: () => import('@/views/web/app/user/edit'),
  },
  {
    name: "新增账号",
    path: "/web/app/user/add",
    hidden: true,
    component: () => import('@/views/web/app/user/add'),
  },
  {
    name: "账号统计",
    path: "/web/app/user/chart",
    hidden: true,
    component: () => import('@/views/web/app/user/chart'),
  },
  //calendar
  {
    name: "日历列表",
    path: "/web/app/calendar/list",
    hidden: true,
    component: () => import('@/views/web/app/calendar/list'),
  },
  //my
  {
    name: "个人资料",
    path: "/web/app/my/list",
    component: () => import('@/views/web/app/my/list'),
  },
  //birthday
  {
    name: "生日管理",
    path: "/web/app/birthday/list",
    component: () => import('@/views/web/app/birthday/list'),
  },
  {
    name: "生日新增",
    path: "/web/app/birthday/add",
    component: () => import('@/views/web/app/birthday/add'),
  },
  {
    name: "生日维护",
    path: "/web/app/birthday/edit",
    component: () => import('@/views/web/app/birthday/edit'),
  },
  {
    name: "生日统计",
    path: "/web/app/birthday/chart",
    component: () => import('@/views/web/app/birthday/chart'),
  },
  //gasoline
  {
    name: "油耗管理",
    path: "/web/app/gasoline/list",
    component: () => import('@/views/web/app/gasoline/list'),
  },
  {
    name: "油耗新增",
    path: "/web/app/gasoline/add",
    component: () => import('@/views/web/app/gasoline/add'),
  },
  {
    name: "油耗统计",
    path: "/web/app/gasoline/chart",
    component: () => import('@/views/web/app/gasoline/chart'),
  },
  //mlove
  {
    name: "生活管理",
    path: "/web/app/mlove/list",
    component: () => import('@/views/web/app/mlove/list'),
  },
  {
    name: "生活新增",
    path: "/web/app/mlove/add",
    component: () => import('@/views/web/app/mlove/add'),
  },
  {
    name: "生活统计",
    path: "/web/app/mlove/chart",
    component: () => import('@/views/web/app/mlove/chart'),
  },
  //expenses
  {
    name: "消费管理",
    path: "/web/app/expenses/list",
    component: () => import('@/views/web/app/expenses/list'),
  },
  {
    name: "消费新增",
    path: "/web/app/expenses/add",
    component: () => import('@/views/web/app/expenses/add'),
  },
  {
    name: "消费统计",
    path: "/web/app/expenses/chart",
    component: () => import('@/views/web/app/expenses/chart'),
  },
  {
    name: "消费维护",
    path: "/web/app/expenses/edit",
    component: () => import('@/views/web/app/expenses/edit'),
  },

  //移动端
  {
    name: "mobile首页",
    path: "/mobile/",
    component: () => import('@/views/mobile/index.vue'),
    meta: {
      title: 'mobile首页',
      requiresAuth: false,
      breadcrumb: '首页'
    }
  },
  //expenses
  {
    name: "APP消费管理",
    path: "/mobile/app/expenses/list",
    component: () => import('@/views/mobile/app/expenses/list'),
    meta: {
      title: 'mobile消费管理',
      requiresAuth: false,
      breadcrumb: '账簿'
    }
  },
  {
    name: "APP新增消费",
    path: "/mobile/app/expenses/add",
    component: () => import('@/views/mobile/app/expenses/add'),
    meta: {
      title: 'mobile消费管理',
      requiresAuth: false,
      breadcrumb: '新增账簿'
    }
  },
  //mlove
  {
    name: "APP生活管理",
    path: "/mobile/app/mlove/list",
    component: () => import('@/views/mobile/app/mlove/list'),
    meta: {
      title: 'mobile生活管理',
      requiresAuth: false,
      breadcrumb: '生活'
    }
  },
  {
    name: "APP生活新增",
    path: "/mobile/app/mlove/add",
    component: () => import('@/views/mobile/app/mlove/add'),
    meta: {
      title: 'mobile生活新增',
      requiresAuth: false,
      breadcrumb: '生活'
    }
  },
  //gasoline
  {
    name: "APP油耗管理",
    path: "/mobile/app/gasoline/list",
    component: () => import('@/views/mobile/app/gasoline/list'),
  },
  {
    name: "APP油耗新增",
    path: "/mobile/app/gasoline/add",
    component: () => import('@/views/mobile/app/gasoline/add'),
  },

];

export default new Router({
  //mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
});



// WEBPACK FOOTER //
// ./src/router/index.js